<template>
  <div class="page-box">

    <div class="page-con">
      <div class="plr16">
        <div class="login-title col-f font30">&nbsp;</div>
        <div class="form-box bg-f">

         <div class="form-title col-theme font22">登录</div>
         <div class="flex login-form mt20">
          <a-input size="large" border="{{true}}" clearable  placeholder="请输入手机号码" v-model:value="tel" bindblur="changeForm"></a-input>
          <a-space> 
            <a-input size="large" border="{{true}}" clearable placeholder="请输入短信验证码" v-model:value="passcode" bindblur="changeForm"></a-input>
            <a-button v-if="sendTime === 0"  size="large" style="width:100%" type="info"  :loading="loading2"  @click="sendcode">
              发送验证码
            </a-button>
            <a-button v-if="sendTime != 0"  size="large"  style="width:100%" type="info"  :disabled="disabled">
              等待 {{sendTime}} 秒
            </a-button>
          </a-space>

          <a-button type="primary" size="large" shape="round" @click="login"  :loading="loading" >登录</a-button>
        </div>


          
        </div>
       
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import { message } from 'ant-design-vue'
  export default {
    name: "login",
    data() {
      return {
        loading:false,
        loading2:false,
        tel:"",
        passcode:"",
        sendTime:0,
        timer: null,
        disabled: false,

      }
    },
    created() {
      clearInterval(this.timer)
      
    },
    beforeDestroy() {
       clearInterval(this.timer)
    },
    methods: {
      ...mapActions([
          'auth_login',
          'auth_smscode'
        ]),
      sendcode(){
          
          let {tel} = this

          if (!tel || tel.length < 11){
            message.error("请输入手机号")
            return
          }
          debugger
          let params = {}
          params.tel = tel
          this.loading2 = true;
          
          this.auth_smscode(params)
          .then((dt) => {
            this.loading2 = false;

            this.sendTime = 60
            this.disabled = true
            clearInterval(this.timer)
            this.timer = setInterval(() => {
              this.sendTime = this.sendTime -1
              if (this.sendTime == 0){
                this.disabled = false
                clearInterval(this.timer)
              }
            }, 1000);
            
          })
          .catch((dt) => {

            this.loading2 = false;
          });


      },
      login(){
        let {tel, passcode} = this
        if (!tel || tel.length < 11){
          message.error("请输入手机号")
          return
        }
        if (!passcode || passcode.length < 4){
          message.error("请输入验证码")
          return
        }
        let params = {}
        params.tel = tel
        params.smscode = passcode
        this.loading = true;
        setTimeout(() => {
          this.auth_login(params)
            .then((dt) => {
              this.loading = false;
              message.success("登录成功")
              localStorage.setItem('t', dt.token)
              localStorage.setItem('name', dt.name)

              this.$router.replace('/home')
            })
            .catch((dt) => {

              this.loading = false;
            });
        }, 500);

        
      },



    }


  };

 


  
  

  


</script>

<style scoped>

.login-form {
  line-height:72px;
}

</style>
